<template>
  <span class="delta-badge" :class="colorClass" :title="tooltip">
    <span v-if="!hasValue">—</span>
    <template v-else>
      <span class="arrow">{{ arrow }}</span>
      <span class="amount">US${{ formatNumber(Math.abs(usd)) }}</span>
      <span v-if="pct !== null && pct !== undefined" class="pct">({{ pctLabel }})</span>
    </template>
  </span>
</template>

<script>
export default {
  name: 'DeltaBadge',
  props: {
    // Variación en USD (puede ser null cuando no hay base de comparación).
    usd: { type: Number, default: null },
    // Variación porcentual (fracción, ej. 0.05 = 5%); null si no aplica.
    pct: { type: Number, default: null },
    // Etiqueta opcional para el tooltip (ej. "Mes anterior", "Día anterior").
    label: { type: String, default: '' }
  },
  computed: {
    hasValue() {
      return this.usd !== null && this.usd !== undefined;
    },
    arrow() {
      if (this.usd > 0) return '▲';
      if (this.usd < 0) return '▼';
      return '＝';
    },
    colorClass() {
      if (!this.hasValue) return 'neutral';
      if (this.usd > 0) return 'up';
      if (this.usd < 0) return 'down';
      return 'flat';
    },
    pctLabel() {
      const sign = this.pct > 0 ? '+' : '';
      return `${sign}${(this.pct * 100).toFixed(1)}%`;
    },
    tooltip() {
      if (!this.hasValue) return this.label ? `${this.label}: sin base de comparación` : '';
      const sign = this.usd > 0 ? '+' : '';
      return `${this.label ? this.label + ': ' : ''}${sign}US$${this.formatNumber(this.usd)}`;
    }
  },
  methods: {
    formatNumber(n) {
      return new Intl.NumberFormat('en-US', { maximumFractionDigits: 0 }).format(Number(n) || 0);
    }
  }
};
</script>

<style scoped>
.delta-badge {
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
}
.delta-badge .pct { font-weight: 400; opacity: 0.85; margin-left: 2px; }
.delta-badge .arrow { margin-right: 2px; }
.up { color: #2e7d32; }
.down { color: #d32f2f; }
.flat, .neutral { color: #8593a3; }
</style>
